// AUT-32 — fait transiter le jeton d'invitation (AUT-08) à travers `/register` et
// `/login`, pour qu'un invité sans Membership ne passe JAMAIS par `AccessDenied`
// entre l'authentification et l'acceptation de son invitation.
//
// AUT-33 : le mécanisme vit désormais dans `packages/ui`
// (`auth/invitationContinuation.ts`), partagé avec web-parent. Ce fichier ne garde
// que la configuration propre à web-admin — un seul type d'invitation, implicite,
// donc des URLs `?invitationToken=…` INCHANGÉES — et la même API qu'avant pour ses
// trois appelants (Register, Login, AcceptInvitation).
import {
  createInvitationContinuation,
  INVITATION_CONTINUATION_STATE,
  isInvitationContinuation,
} from '@monecolier/ui';

const continuation = createInvitationContinuation({
  acceptPaths: { staff: '/accept-invitation' },
  defaultKind: 'staff',
});

export { INVITATION_CONTINUATION_STATE, isInvitationContinuation };

export function readInvitationToken(searchParams: URLSearchParams): string | null {
  return continuation.read(searchParams)?.token ?? null;
}

/** `/register` ou `/login`, avec le jeton propagé s'il y en a un. */
export function withInvitationToken(path: '/register' | '/login', token: string | null): string {
  return continuation.authPath(path, token ? { kind: 'staff', token } : null);
}

export function acceptInvitationPath(token: string): string {
  return continuation.acceptPath({ kind: 'staff', token });
}
